<template>
  <div class="p-grid paddedCol p-text-center mt-3">
    <div v-if="isLoading" class="isLoadingDiv p-col-12 p-text-center">
      <ProgressSpinner />
    </div>
    <div v-else class="p-grid p-text-left" style="width: 100%">
      <UpgradeBanner v-if="currentUser && !currentUser.upgraded" />
      <div class="p-col-12 p-my-3">
        <h1 class="title is-1 displayInline">
          {{ $t("leagues-store-getters-leagueinformation-length", [$store.getters.leagueInformation.length]) }}
        </h1>
      </div>
      <div
        v-for="league in $store.getters.leagueInformation"
        :key="league.id"
        class="p-col-12 rounded whiteBg paddedCol p-my-3"
      >
        <h2 class="title is-3">
          <img
            v-if="league.se_id"
            class="se_indicator"
            v-tooltip="`SportsEngine ID: ${league.se_id}`"
            src="/se_logo_small.png"
          />
          <img v-if="league.se_imported" class="se_indicator" src="/se_logo_small.png" alt="SE Logo" />
          {{ league.name }}

          <Button
            @click="startDeleteLeague(league)"
            :label="$t('Button.delete')"
            class="p-button-outlined p-button-sm p-button-danger floatRight p-ml-2"
          />

          <Button
            @click="startEditLeague(league)"
            :label="$t('Button.edit')"
            class="p-button-outlined p-button-sm floatRight p-ml-2"
          />

          <Button
            @click="downloadLeague(league)"
            :label="$t('download')"
            class="p-button-outlined p-button-sm floatRight p-ml-2"
          />
        </h2>
        <div class="title is-5">{{ $t("seasons-league-seasons-length", [league.seasons.length]) }}</div>
        <div v-for="season in league.seasons" :key="season.id">
          <div>
            <Button class="p-button-text p-button-plain" @click="setAndGo(league.id, season.id)">
              <img
                v-if="season.se_imported || season.se_id"
                class="se_indicator"
                v-tooltip="`SportsEngine ID: ${season.se_id}`"
                src="/se_logo_small.png"
                alt="SE Logo"
              />
              {{ season.name }}
            </Button>
            <Button
              @click="startEditSeason(season)"
              :label="$t('Button.edit')"
              class="p-button-text p-button-sm p-ml-1"
            />
            <Button
              @click="startDeleteSeason(season)"
              :label="$t('Button.delete')"
              class="p-button-text p-button-sm p-button-danger p-ml-1"
            />
          </div>
        </div>
      </div>
    </div>

    <Dialog
      :header="theLeague ? 'Delete League' : 'Delete Season'"
      :visible.sync="deleteDialog"
      :style="{ width: '600px', maxWidth: '90vw' }"
      :modal="true"
    >
      <div v-if="isBusy">
        <ProgressSpinner />
      </div>
      <div v-else-if="theLeague">
        {{ $t("are-you-sure") }} <br /><br />{{
          $t("this-will-delete-all-seasons-games-teams-divisions-etc-associated-with-the-league")
        }}
        <strong>{{ $t("this-cannot-be-undone") }} </strong>
        <div class="p-mt-5">
          <Button @click="deleteDialog = false" :label="$t('keep-league')" class="p-button-lg" />
          <br /><br />
          <Button
            :disabled="isBusy"
            @click="deleteLeague"
            :label="$t('delete-league-and-all-associated-data')"
            class="p-button-text p-button-danger"
          />
        </div>
      </div>
      <div v-else-if="theSeason">
        {{ $t("are-you-sure") }} <br /><br />{{
          $t("this-will-delete-all-games-teams-divisions-etc-associated-with-the-season")
        }}
        <strong>{{ $t("this-cannot-be-undone") }} </strong>
        <div class="p-mt-5">
          <Button @click="deleteDialog = false" :label="$t('keep-season')" class="p-button-lg" />
          <br /><br />
          <Button
            @click="deleteSeason"
            :disabled="isBusy"
            :label="$t('delete-season-and-all-associated-data')"
            class="p-button-text p-button-danger"
          />
        </div>
      </div>
    </Dialog>

    <!-- UPDATE -->
    <Dialog
   
      :header="theLeague ? $t('edit-league') : $t('edit-season')"
      :visible.sync="updateDialog"
      :style="{ width: '600px', maxWidth: '90vw' }"
      :modal="true"
    >
      <div v-if="theLeague" class="p-mt-1">
        <InputText v-model="theLeague.name" style="width: 90%" :placeholder="$t('Division.name')" autofocus="true" />
        <div class="p-mt-5">
          <Button @click="updateLeague" :label="$t('Button.save')" class="p-button-lg" />
        </div>
      </div>
      <div v-else-if="theSeason" class="p-mt-1">
        <InputText v-model="theSeason.name" style="width: 90%" :placeholder="$t('Division.name')" autofocus="true" />
        <div class="p-mt-5">
          <Button @click="updateSeason" :label="$t('Button.save')" class="p-button-lg" />
        </div>
      </div>
    </Dialog>
  </div>
</template>

<script>
import api from "@/api";

export default {
  components: {},
  data() {
    return {
      isBusy: false,
      leagues: [],
      isLoading: true,
      searchString: "",
      searching: false,
      searchTimer: null,
      theLeague: null,
      theSeason: null,
      deleteDialog: false,
      updateDialog: false,
    };
  },
  computed: {},
  watch: {},
  methods: {
    downloadLeague(league) {
      api
        .getLeagueJSON(league.id)
        .then(response => {
          var data = "text/json;charset=utf-8," + encodeURIComponent(JSON.stringify(response.data));
          var a = document.createElement("a");
          a.href = "data:" + data;
          a.download = league.name + ".json";
          a.innerHTML = this.$t("download-json");
          a.click();
          // console.log(data)
        })
        .catch(e => {
          console.log("error", e);
        });
    },
    setAndGo(lid, sid) {
      this.setCurrentLeagueSeasonId(lid, sid);
      this.goRouter("/");
      this.makeToast("info", this.$t("switched-to-season"));
    },
    startDeleteSeason(season) {
      this.theLeague = null;
      this.theSeason = season;
      this.deleteDialog = true;
    },
    startDeleteLeague(league) {
      this.theSeason = null;
      this.theLeague = league;
      this.deleteDialog = true;
    },
    startEditSeason(season) {
      this.theLeague = null;
      this.theSeason = season;
      this.updateDialog = true;
    },
    startEditLeague(league) {
      this.theSeason = null;
      this.theLeague = league;
      this.updateDialog = true;
    },
    updateSeason() {
      api
        .updateSeason(this.theSeason)
        .then(response => {
          console.log(response);
          this.trackEvent("Deleted Season", { league: this.theSeason });
          this.$store.dispatch("getLeagueInformation");
          this.makeToast("success", this.$t("updated-season"));
          this.reset();
        })
        .catch(e => {
          console.log(e);
        });
    },
    updateLeague() {
      api
        .updateLeague(this.theLeague)
        .then(response => {
          this.trackEvent("Updated League", { league: this.theLeague });
          console.log(response);
          this.$store.dispatch("getLeagueInformation");
          this.makeToast("success", this.$t("updated-league"));
          this.reset();
        })
        .catch(e => {
          console.log(e);
        });
    },
    deleteSeason() {
      this.isBusy = true;
      api
        .deleteSeason(this.theSeason)
        .then(response => {
          this.trackEvent("Deleted Season", { league: this.theSeason });
          console.log(response);
          this.$store.dispatch("getLeagueInformation");
          this.makeToast("success", this.$t("delete-season"));
          this.reset();
          this.isBusy = false;
        })
        .catch(e => {
          console.log(e);
        });
    },
    deleteLeague() {
      this.isBusy = true;
      api
        .deleteLeague(this.theLeague)
        .then(response => {
          console.log(response);
          this.trackEvent("Deleted League", { league: this.theLeague });
          this.makeToast("success", this.$t("delete-league"));
          this.fetchData();
          this.$store.dispatch("getLeagueInformation");
          this.reset();
          this.isBusy = false;
        })
        .catch(e => {
          console.log(e);
          this.reset();
        });
    },
    reset() {
      this.updateDialog = false;
      this.deleteDialog = false;
      this.theSeason = null;
      this.theLeague = null;
      this.isBusy = false;
    },
    fetchData() {
      this.isLoading = true;
      api
        .getLeagues()
        .then(response => {
          this.leagues = response.data.leagues;
          console.log("leagues: ", this.leagues);
          if (!this.leagues.length) {
            this.goRouter("/");
            return;
          }
          this.isLoading = false;
        })
        .catch(e => {
          console.log(e);
          this.refreshLeagueInformation("/");
        });
    },
  },
  created() {
    this.fetchData();
  },
  mounted() {
    window.analytics.page();
  },
};
</script>

<style scoped lang="scss">
#bigSearch {
  width: 100%;
  background: white;
  font-size: 1.2em;
  padding: 10px 20px;
}
.searchResults {
  font-size: 1.5em;
}
</style>
